module.exports = __webpack_public_path__ + "img/expert-5.3223b607.png";